import gql from 'graphql-tag'
import client from '../../stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteBuilding: { building: { id: string } }
}

const mutateHandler = handleFetchResult<IPayload, { id: string }>({
  handler: (data) => data.deleteBuilding.building,
  name: 'Building',
})

export default function remove(id: string) {
  return client.gql.mutate({ mutation, variables: { input: { id } } }).then(mutateHandler)
}

const mutation = gql`
  mutation RemoveBuilding($input: DeleteBuildingMutationInput!) {
    deleteBuilding(input: $input) {
      building {
        id
      }
    }
  }
`
